module.exports = __webpack_public_path__ + "static/media/view5.a9f01499.jpg";